import React, { useMemo, useLayoutEffect } from 'react';
import { TrackingProp } from 'react-tracking';
import { SEO } from 'components/SEO';
import Show from 'components/Functional/Show';
import OverlayComponents from './OverlayComponents';
import Header from 'components/Header';
import Footer from 'components/Footer';
import useAccessibe from 'hooks/useAccessibe';
import { useTikTok } from 'hooks/useTikTok';
import { Container, GlobalLayoutWrapper } from './styled';
import { PromoBannerESIBlock } from 'components/PromoBannerESIBlock';
import { SegmentConsentBanner } from 'components/SegmentConsentBanner';
import { ProductAssistant } from 'components/ProductAssistant';
import { TemplatePageContext } from 'types/Navigation';
interface GlobalLayoutProps {
  children: React.ReactNode;
  bottomContent?: React.ReactNode;
  contained?: boolean;
  displayPromoBanner?: boolean;
  displayFooter?: boolean;
  displayProductAssistant?: boolean;
  tracking?: TrackingProp;
  contentPage?: boolean;
  width?: string;
  templatePageContext?: TemplatePageContext;
}

const GlobalLayout = ({
  children,
  displayPromoBanner = false,
  displayProductAssistant = false,
  displayFooter = true,
  contained = true,
  bottomContent = null,
  contentPage = false,
  width,
  templatePageContext
}: GlobalLayoutProps): React.JSX.Element => {
  useAccessibe();
  useTikTok();

  useLayoutEffect(() => {
    function handleResize() {
      const vh = window.visualViewport ? window.visualViewport.height : window.innerHeight;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    }
    handleResize();

    window.addEventListener('resize', handleResize);
    window.visualViewport.addEventListener('resize', handleResize);
    return () => {
      window.visualViewport.removeEventListener('resize', handleResize);
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return useMemo(
    () => (
      <>
        <GlobalLayoutWrapper className="GlobalLayout">
          <SEO title="Artifact Uprising | Premium Photo Printing for Your Stories" />
          <Show when={displayPromoBanner}>
            <PromoBannerESIBlock />
          </Show>
          {contained ? (
            <div>
              <Header />
              <Container contentPage={contentPage} width={width}>
                {children}
              </Container>
              {bottomContent}
            </div>
          ) : (
            <>
              <Header />
              {children}
            </>
          )}
          {displayFooter && <Footer />}
        </GlobalLayoutWrapper>
        <OverlayComponents />
        <SegmentConsentBanner />
        {displayProductAssistant && <ProductAssistant templatePageContext={templatePageContext} />}
      </>
    ),
    // TODO: Refactor these dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [bottomContent, displayPromoBanner, children, contained, displayFooter]
  );
};
export default GlobalLayout;
